import { z } from 'zod';

export const SChatwootConversation = z.object({
  assignee_id: z.null(),
  unread_count: z.number(),
  last_activity_at: z.number(),
  contact_inbox: z.object({ source_id: z.string() }),
});
